import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { config } from '../../config';
import { togglePopover } from '../../redux/Slices/popoverSlice';
import { showSuccess, showError } from "../../utils/snackbarHelpers";

import './scss/DeleteCard.scss';
import { removeArchivedCard } from '../../redux/Slices/cardSlice';


const DeleteCard = ({ cardId }) => {
    const inputRef = useRef(null);
    const { card = {} } = useSelector((state) => state.card) || {};
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const handleDeleteCard = async () => {
        setLoading(true);
        try {
            const response = await fetch(config.API_URI + `/v1/cards/delete/${cardId || card?.shortId}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error('Failed to delete the card');
            }

            dispatch(removeArchivedCard(cardId || card?.shortId));

            const data = await response.json();
            dispatch(togglePopover({ contentId: null, position: { top: 0, left: 0 }, targetId: null }));

            if (card?.boardLink) {
                navigate(card.boardLink);
            }

        } catch (error) {
            console.error('Error deleting the card:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="delete-card">
            <h2>Delete?</h2>

            <div className="group">
                <p className='warning-message'>Deleting this card will remove all actions from the activity feed, and you cannot re-open it. This action cannot be undone.</p>
                <button onClick={() => handleDeleteCard()} disabled={loading}>
                    {loading ? 'Deleting...' : 'Delete'}
                </button>
            </div>
        </div>
    );
};

export default DeleteCard;
